<template>
  <div class="column">
    <div class="container container_com-fundo container_com-margem">

        <div class="filtros-escolhidos print">
        <h2 class="title-print" >
          EMPREENDIMENTOS
        </h2>
      </div>

      <div class="columns search buscar-solicitacoes no-print">
        <form @submit.prevent="obterEmpreendimentos(1)" class="formulario">
          <div class="grade__linha grade__linha_alinhar-vertical-a-base">
            <div class="grade__coluna grade__coluna_2">
              <label for="projeto">Projeto</label>
              <select
                id="projeto"
                name="projeto"
                v-model="projeto">
                <option v-for="projeto in projetos" :value="projeto.Id">
                  {{ projeto.Nome }}
                </option>
              </select>
            </div>
            <div class="grade__coluna grade__coluna_3">
              <label for="empreendimento">Empreendimento</label>
              <input
                v-model="empreendimento"
                id="empreendimento"
                name="empreendimento"
                type="text"
                maxlenght="90"
                placeholder="Ex: Residencial..."
              />
            </div>
            <div class="grade__coluna grade__coluna_2">
              <label for="cnpjDaConstrutora">CNPJ da construtora</label>
              <input
                v-model="cnpjDaConstrutora"
                id="cnpjDaConstrutora"
                name="cnpjDaConstrutora"
                type="text"
                maxlenght="90"
                placeholder="Ex: 11.754.463/0001-65"
                v-mask="'99.999.999/9999-99'"
              />
            </div>
            <div class="grade__coluna grade__coluna_3">
              <label for="cidade">Cidade do empreendimento</label>
              <select
                id="cidade"
                name="cidade"
                v-model="cidade">
                <option v-for="cidade in cidades" :value="cidade.Id">
                  {{ cidade.Nome }}
                </option>
              </select>
            </div>
          </div>
          <div class="grade__linha grade__linha_alinhar-vertical-a-base">
            <div class="grade__coluna grade__coluna_1">
              <button type="submit" class="botao botao_cinza botao_grande">
                Filtrar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="container container_com-fundo container_com-margem">
      <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <div class="columns search buscar-solicitacoes no-print">
        <div class="column control">
          <router-link :to="{ name: 'CadastrarEmpreendimento' }" class="botao botao_medio botao_cor-terciaria">
            <span>Novo empreendimento</span>
          </router-link>
        </div>
      </div>
      <table class="tabela tabela_listrada tabela_com-largura-total">
        <thead>
          <tr>
            <th>Empreendimento</th>
            <th>Cidade</th>
            <th>Construtora</th>
            <th>Projeto</th>
            <th class="u-texto-alinhado-ao-centro">Cotas</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="empreedimento of empreendimentos" v-if="empreendimentos.length > 0" :id="empreedimento.Id">
            <td>
              {{ empreedimento.Nome }}
            </td>
            <td>
              {{ empreedimento.Cidade.Nome }}
            </td>
            <td>
              {{ empreedimento.Construtora.Nome }}
            </td>
            <td>
              {{ empreedimento.ProjetoDeSubsidioNome }}
            </td>
            <td v-if="empreedimento.ProjetoEhBonusMoradia" class="u-texto-alinhado-ao-centro">
              {{empreedimento.CotasDeImoveisUsadas}} /{{empreedimento.CotaDeImoveis}}
            </td>
            <td v-if="!empreedimento.ProjetoEhBonusMoradia" class="u-texto-alinhado-ao-centro">
              Não possui cota
            </td>
            <td class="ver-detalhes no-print">
              <div>
                <button type="button" @click="redirecionarParaVisualizacao(empreedimento.Id)" class="botao botao_cor-terciaria botao_contorno botao_pequeno">Visualizar</button>
              </div>
            </td>
          </tr>
          <tr v-if="empreendimentos.length === 0">
            <td colspan="6">
              Nenhum empreendimento encontrado
            </td>
          </tr>
        </tbody>
      </table>
      <paginacao @paginar="obterEmpreendimentos" :paginaAtual="paginaAtual" :totalDePaginas="totalDePaginas" :totalDeRegistros="totalDeRegistros"/>
    </div>
  </div>
</template>

<script>
import AwesomeMask from 'awesome-mask';
import Loading from '../shared/Loading';
import Alerta from '../shared/Alerta';
import Paginacao from "../shared/Paginacao";

export default {
  name: 'lista-de-empreendimentos',
  components: { Loading, Alerta, Paginacao },
  data() {
    return {
      empreendimentos: this.empreendimentos || [],
      projeto: null,
      projetos:[],
      cidade: null,
      cidades: this.cidades || [],
      empreendimento: null,
      cnpjDaConstrutora:null,
      paginaAtual: 0,
      totalDePaginas: null,
      totalDeRegistros: null,
      loading: {
        visivel: false,
      },
      mensagemDeAlerta: null,
      tipoDeAlerta: null,
    };
  },
  created() {
    this.obterEmpreendimentos(1);

    this.$api
      .get("/Projeto/ObterVigentes")
      .then((response) => {
        this.projetos = [{ Id: null, Nome: "Selecione o projeto" }];
        this.projetos = this.projetos.concat(response.data);

        return response;
      })
      .catch((error) => {
        console.error(error);
      });

    this.$api
      .get("/Cidade/ObterCidadesDosEmpreendimentos")
      .then((response) => {
        this.cidades = [{ Id: null, Nome: "Selecione uma cidade" }];
        this.cidades = this.cidades.concat(response.data);
        return response;
      })
      .catch((error) => {
        this.tratarErro(error);
      });
  },
  directives: { mask: AwesomeMask },
  methods: {
    obterEmpreendimentos(pagina) {
      this.exibirCarregamento();
      const filtro = {
        pagina: pagina,
        projetoId: this.projeto,
        nomeDoEmpreendimento: this.empreendimento,
        cnpjDaConstrutora: this.cnpjDaConstrutora,
        cidadeId: this.cidade
      };

      this.$api.post('/Empreendimento/ObterPaginados', filtro)
        .then((response) => {
          this.esconderCarregamento();
          this.empreendimentos = response.data.Modelo;
          this.paginaAtual = response.data.PaginaAtual;
          this.totalDePaginas = response.data.TotalDePaginas;
          this.totalDeRegistros = response.data.TotalDeRegistros;
        }).catch((error) => {
          this.esconderCarregamento();
          this.tratarErro(error);
        });
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
      window.scrollTo(0, 0);
    },
    exibirMensagemDeSucesso(mensagem) {
      this.tipoDeAlerta = 'success';
      this.mensagemDeAlerta = mensagem;
      window.scrollTo(0, 0);
    },
    tratarErro(error) {
      this.esconderCarregamento();
      this.tipoDeAlerta = 'erro';
      const mensagensDeErro = error.response.data.Message;
      this.mensagemDeAlerta = mensagensDeErro || 'Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte';
    },
    redirecionarParaVisualizacao(empreedimentoId) {
      this.$router.push({ name: 'VisualizarEmpreendimento', query: { idDoEmpreendimento: empreedimentoId } });
    }
  },
};
</script>



// WEBPACK FOOTER //
// ListaDeEmpreendimentos.vue?4398ca5e